import { useState, useEffect } from 'react';
import { WifiOff, RefreshCw } from 'lucide-react';

export function NetworkStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [isRetrying, setIsRetrying] = useState(false);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  // Auto-retry when offline
  useEffect(() => {
    if (isOnline) return;

    setIsRetrying(true);
    const interval = setInterval(async () => {
      try {
        const res = await fetch('/api/health', { method: 'HEAD', cache: 'no-store' });
        if (res.ok) {
          setIsOnline(true);
          setIsRetrying(false);
        }
      } catch {
        // Still offline
      }
    }, 5000);

    return () => {
      clearInterval(interval);
      setIsRetrying(false);
    };
  }, [isOnline]);

  if (isOnline) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] bg-danger/90 backdrop-blur-sm text-white text-sm py-2 px-4 flex items-center justify-center gap-2" role="alert">
      <WifiOff className="w-4 h-4" />
      <span>Connection lost</span>
      {isRetrying && (
        <>
          <span className="text-white/70">—</span>
          <RefreshCw className="w-3 h-3 animate-spin" />
          <span className="text-white/70">retrying...</span>
        </>
      )}
    </div>
  );
}
